<h1 matDialogTitle>TFG Account Payment</h1>

<mat-dialog-content>
  <p>
    Tender the amount to be paid into the TFG acoount
  </p>
  <app-pos-capture-payment (paymentChanged)="paymentChanged($event)" [paymentType]="'TFG-ACCOUNT'" [amountOutstanding]="tfgAccountDetails.accountBalanceAmount"></app-pos-capture-payment>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button [disabled]="!formValid || busy" mat-button (click)="save()">Save</button>
</mat-dialog-actions>
